export default __webpack_public_path__ + "static/media/Icons_Water Icon.cb5220f8.svg";